import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Chip } from '@mui/material'

import { Patient } from '@/core/models/patient.model'

type AccountStatusProps = {
  patient: Patient
}

export function AccountStatus({ patient }: AccountStatusProps) {
  useLingui()

  return patient.account ? (
    <Chip label={t`Account active`} color="success" size="small" />
  ) : (
    <Chip label={t`No account`} color="default" size="small" />
  )
}
